import React, { useState, useEffect } from 'react';
import  * as Util from '../../data/General';
import { DayPicker } from 'react-day-picker';
import { es } from 'date-fns/locale';

import 'react-day-picker/dist/style.css';

function Filter(props) {
    let { filter, setFilter, fromText="fromUpdateDate", toText="toUpdateDate", className="", isIntervalShow=true } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(-1);
    const [endDate, setEndDate] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    const [endDateSelect, setEndDateSelect] = useState(null);
    const [startDateSelect, setStartDateSelect] = useState(null);
    const [selectedText, setSelectedText] = useState(null);
    const [isFist, setIsFist] = useState(true);
    const days = {
        0:{day: 0, title: Util.getMessage("Today")},
        1: {day: 1, title: Util.getMessage("Yesterday")},
        7: {day: 7, title: Util.getMessage("fl_7")},
        30: {day: 30, title: Util.getMessage("fl_30")},
        90: {day: 90, title: Util.getMessage("fl_90")},
        360: {day: 360, title: Util.getMessage("fl_360")},
    };
    const [interval, setInterval] = useState("day");
    const intervalList = {
        "hour": {title: Util.getMessage("hour")},
        "day": {title: Util.getMessage("day")},
        "month": {title: Util.getMessage("month")}
    };

    let sort= "";
    let sortText= "";
    /*startDate.setDate(endDate.getDate() - 360);*/
    const defaultSelected = {
        from: startDate,
        to: endDate
      };

    
    const [range, setRange] = useState(defaultSelected);
    const [rangeCustom, setRangeCustom] = useState(null);


    const setSortOrder = (rangeAux) => {
        if(filter){
            filter[fromText] = rangeAux.from.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'}) + "T00:00:01";
            filter[toText] = rangeAux.to.toLocaleDateString('en-CA', {year: 'numeric', month: '2-digit', day: '2-digit'})+ "T23:59:59";
            if(isIntervalShow){
                filter["interval"] = rangeAux.interval;
            }
            if (setFilter) {
                setFilter(filter);
            }
        }
    }

    const [count, setCount] = useState(1);
    
    const setRangeClick = (ran) =>{
        let selDate = selectedDate;
        if(ran && ran.from && ran.to){
            setRangeCustom(ran);
            setSelectedDate(-1);
            selDate= -1;
            setInterval("custom"+count);
            setCount(count+1);
        }
        if(selDate === -1){
            if(startDateSelect === null && ran.from !== null){
                setStartDateSelect(ran.from);
                setCustmRange(ran.from, ran.from, false);
            }else if(endDateSelect === null && ran.to !== null){
                setEndDateSelect(ran.to);
                setCustmRange(startDateSelect, ran.to);
                let rangeAux = {
                    from: startDateSelect,
                    to: ran.to
                };
                setRange(rangeAux);
                openFilter(1000);
            }
        }else{
            setStartDateSelect(null);
            setEndDateSelect(null);
        }
    }

    const setCustmRange = (from, to, isSetFilter=true) =>{
        let startDate = new Date(from);
        let endDate = new Date(to);
        
        let rangeAux = {
            from: startDate,
            to: endDate
        };
        if(isIntervalShow){
            rangeAux["interval"] = interval
        }
        setRange(rangeAux);
        if(isSetFilter){
            setSortOrder(rangeAux);
        }
        setSelectedText(" ("+ startDate.getDate() + "/"+ startDate.getMonth() + "/"+startDate.getFullYear() +" - " + endDate.getDate() + "/"+ endDate.getMonth()+ "/"+ endDate.getFullYear()+")");
    }
    
    useEffect(() => {
        let rangeAux;
        if(selectedDate !== -1){
            let startDate = new Date();
            let endDate = new Date();
            startDate.setDate(endDate.getDate() - selectedDate);
            rangeAux = {
                from: startDate,
                to: endDate
            };
            if(isIntervalShow){
                rangeAux["interval"] = interval
            }
            setRange(rangeAux);
            setSortOrder(rangeAux);
             setSelectedText(" ("+ startDate.getDate() + "/"+ startDate.getMonth() + "/"+startDate.getFullYear() +" - " + endDate.getDate() + "/"+ endDate.getMonth()+ "/"+ endDate.getFullYear()+")");
            openFilter();
        }else{
            /*let startDate = new Date(rangeCustom.from);
            let endDate = new Date(rangeCustom.to);
            
            let rangeAux = {
                from: startDate,
                to: endDate
            };
            if(isIntervalShow){
                rangeAux["interval"] = interval
            }
            setRange(rangeAux);
            setSortOrder(rangeAux);*/
        }
        
    },[selectedDate, interval]);  

    const clearFilter = () => {
        setIsOpen(!isOpen); 
        setSelectedDate(-1);
        setStartDateSelect(null);
        setEndDateSelect(null);
        setRangeCustom(null);
        setEndDate(new Date());
        setStartDate(new Date());
        let defaultSelected = {
            from: new Date(),
            to: new Date()
        };
        setRange(defaultSelected);
    }

    const openFilter = (timer=0) =>{
        if(timer === 0){
           clearFilter(); 
        }else{
            setTimeout(function(){clearFilter();}.bind(this), timer);
        }
    }
       
      return (
        <div className={'filters-content content-flex ' + className}>
            <button onClick={() => openFilter()} className="btn-filter content-flex flex-center">
                <img src='img/calendar.png' className="img-b bup" />
                <span>{days[selectedDate] ? days[selectedDate].title : Util.getMessage("Filter")}{selectedText ? selectedText : ""}</span>
            </button>
            <div>
                {sort !== "" && (
                    <div className="filters-apllied" onClick={() => this.clearSort()}>
                        <i className="icofont-navigation"></i> {sortText}
                        <i className="icofont-close-squared-alt"></i>
                    </div>  
                )}
            </div>
            {isOpen && (
                <div className="filter">
                    <div><button onClick={() => openFilter()} className="close-icon"><i className="icofont-close-circled"></i></button></div>
                    <div className='content-flex'>
                        <div>
                            <ul>
                                {Object.keys(days).map((day, key) => (
                                    <li key={key} onClick={() => {setSelectedDate(days[day].day);}} className={(days[day].day === selectedDate) ? 'selected' : ''}>{days[day].title}</li>
                                ))}
                            </ul>
                            {isIntervalShow ? (
                                <>
                                    <hr/>
                                    <ul>
                                        {Object.keys(intervalList).map((day, key) => (
                                            <li key={key} onClick={() => {setInterval(day);}} className={(day === interval) ? 'selected' : ''}>{intervalList[day].title}</li>
                                        ))}
                                    </ul>
                                </>) : null}
                        </div>
                        <DayPicker
                            id="test"
                            mode="range"
                            locale={es}
                            toDate={new Date()}
                            selected={range}
                            numberOfMonths={2}
                            onSelect={setRangeClick}
                        />
                    </div>
                </div>

            )}    
        </div>
            
      );

}

export default Filter;
